import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "703",
  height: "636",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "m1 2 697.5 323.5-527.5 308",
      stroke: "url(#a)",
      "stroke-width": "4"
    }, null, -1),
    _createElementVNode("defs", null, [
      _createElementVNode("linearGradient", {
        id: "a",
        x1: "11.5",
        y1: "-123.5",
        x2: "349.75",
        y2: "633.5",
        gradientUnits: "userSpaceOnUse"
      }, [
        _createElementVNode("stop", { "stop-color": "#FDBD00" }),
        _createElementVNode("stop", {
          offset: ".957405",
          "stop-color": "#FDBD00",
          "stop-opacity": "0"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }